import apiSlice from '../api/api.slice';

export const attachmentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPreSignedUrl: builder.query<string, { attachmentId: string }>({
      query: (params) => ({
        url: '/api/v1/attachment/getPreSignedUrl',
        method: 'GET',
        params,
      }),
      transformResponse: (response: { status: string; signedURL: string }) =>
        response.signedURL,
    }),
  }),
});

export const { useGetPreSignedUrlQuery, useLazyGetPreSignedUrlQuery } =
  attachmentApiSlice;
